"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "az-arab": 9143,
    "az-cyrl": 9144,
    "az-latn": 9145,
    "be-latn": 9146,
    "bs-cyrl": 9147,
    "bs-latn": 9148,
    "de-1901": 9149,
    "de-1996": 9150,
    "de-at-1901": 9151,
    "de-at-1996": 9152,
    "de-ch-1901": 9153,
    "de-ch-1996": 9154,
    "de-de-1901": 9155,
    "de-de-1996": 9156,
    "en-boont": 9157,
    "en-scouse": 9158,
    "es-419": 9159,
    "iu-cans": 9160,
    "iu-latn": 9161,
    "mn-cyrl": 9162,
    "mn-mong": 9163,
    "sgn-br": 9164,
    "sgn-co": 9165,
    "sgn-de": 9166,
    "sgn-dk": 9167,
    "sgn-es": 9168,
    "sgn-fr": 9169,
    "sgn-gb": 9170,
    "sgn-gr": 9171,
    "sgn-ie": 9172,
    "sgn-it": 9173,
    "sgn-jp": 9174,
    "sgn-mx": 9175,
    "sgn-ni": 9176,
    "sgn-nl": 9177,
    "sgn-no": 9178,
    "sgn-pt": 9179,
    "sgn-se": 9180,
    "sgn-us": 9181,
    "sgn-za": 9182,
    "sl-nedis": 9183,
    "sl-rozaj": 9184,
    "sr-cyrl": 9185,
    "sr-latn": 9186,
    "tg-arab": 9187,
    "tg-cyrl": 9188,
    "uz-cyrl": 9189,
    "uz-latn": 9190,
    "yi-latn": 9191,
    "zh-cmn": 9192,
    "zh-cmn-hans": 9193,
    "zh-cmn-hant": 9194,
    "zh-gan": 9195,
    "zh-hans": 9196,
    "zh-hans-cn": 9197,
    "zh-hans-hk": 9198,
    "zh-hans-mo": 9199,
    "zh-hans-sg": 9200,
    "zh-hans-tw": 9201,
    "zh-hant": 9202,
    "zh-hant-cn": 9203,
    "zh-hant-hk": 9204,
    "zh-hant-mo": 9205,
    "zh-hant-sg": 9206,
    "zh-hant-tw": 9207,
    "zh-wuu": 9208,
    "zh-yue": 9209
};
//# sourceMappingURL=redundant.json.js.map